import script from "./XInputCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./XInputCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./XInputCheckbox.vue?vue&type=style&index=0&id=aa8effc8&lang=css"

const __exports__ = script;

export default __exports__